export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create(_, data) {
      return {
        canvasScaleMethod: 'scroll',
        /* ------------ TODO MOVE ---------*/
        width: 1500,
        height: 800,
        backgroundColor: '#000000',
        allHeadlinesFontSize: 24,
        allCommitmentsFontSize: 15,
        showAllCommitments: true,
        showAllHeadlines: true,
        showAllProgress: true,
        customText: [],
        groupItems: false,
        previewBase64: '',
        goals: [],
        commitments: [],
        features: {
          clock: {},
          quote: {}
        },
      };
    },

    fields: {
      canvasScaleMethod: {},
      /* ------------ TODO MOVE ---------*/
      width: {},
      height: {},
      backgroundColor: {},
      allHeadlinesFontSize: {},
      allCommitmentsFontSize: {},
      showAllCommitments: {},
      showAllHeadlines: {},
      showAllProgress: {},
      customText: {},
      groupItems: {},
      previewBase64: {},
      goals: {},
      commitments: {},
      features: {}
    }
  }
};
